export default __webpack_public_path__ + "static/media/JamieConstantine-min.62c7c529.jpg";